import { render, staticRenderFns } from "./AddAdditionalCategories.vue?vue&type=template&id=9050f95a&scoped=true"
import script from "./AddAdditionalCategories.vue?vue&type=script&lang=js"
export * from "./AddAdditionalCategories.vue?vue&type=script&lang=js"
import style0 from "./AddAdditionalCategories.vue?vue&type=style&index=0&id=9050f95a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9050f95a",
  null
  
)

export default component.exports